import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { HighlySensitiveDataMaskedDisplay } from '../dataSensitivity/HighlySensitiveDataMaskedDisplay';
import { getDataAttributes } from '../utils/getDataAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormattedHighlySensitive = props => {
  useComponentMountMetric('FormattedHighlySensitive');
  return /*#__PURE__*/_jsx(HighlySensitiveDataMaskedDisplay, {
    dataAttributes: getDataAttributes(props)
  });
};